<template>
    <div class="c-o-search-results">
        <transition name="o-transition--fade-short" mode="out-in">
            <div v-if="!isLoading && !error" key="content" class="c-o-search-results__inner">
                <div v-if="requests.data.length > 0" class="c-o-search-results__cards c-o-search-results__cards--50-50">
                    <div class="c-o-search-results__card" v-for="request in requests.data" :key="`search-results-company-${request.Id}`">
                        <card :request="request"></card>
                    </div>
                </div>
                <empty-state v-else-if="!requests.data.length" :body="'<p>Försök bredda din sökning.</p>'"></empty-state>
                <pagination
                    :totalItemsProp="nrOfRequests"
                    :itemsPerPageProp="searchParams.take"
                    :maxPagesToShowProp="10"
                    :currentPageProp="searchParams.page"
                    @changed="setPageAndFetch"
                    ></pagination>
            </div>
            <div v-else-if="isLoading && !error" key="loading" class="c-o-search-results__inner">
                <loader></loader>
            </div>
            <div v-else-if="!isLoading && error" key="error" class="c-o-search-results__inner">
                <error-state></error-state>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import {
        FETCH_REQUESTS,
        SET_PAGE_ACTION,
        GET_REQUESTS,
        GET_SEARCH_PARAMS,
        IS_LOADING,
        GET_ERROR }
        from '../../../../store/store-models/requests-model';

    import EmptyState from '../../molecules/MoleculeEmptyState.vue'
    import Loader from '../../molecules/MoleculeLoader.vue'
    import ErrorState from '../../molecules/MoleculeErrorState.vue'
    import Card from '../../molecules/MoleculeCardRequest.vue'
    import AtomButton from '../../atoms/AtomButton.vue'
    import Pagination from '../../molecules/MoleculePagination.vue'

    export default {
        components: {
            EmptyState,
            Loader,
            ErrorState,
            Card,
            AtomButton,
            Pagination
        },
        computed: {
            ...mapGetters({
                requests: GET_REQUESTS,
                searchParams: GET_SEARCH_PARAMS,
                isLoading: IS_LOADING,
                error: GET_ERROR
            }),
            nrOfRequests: function(){
                return !this.isLoading ? this.requests.meta.count : 0
            }
        },
        methods: {
            ...mapActions({
                setPage: SET_PAGE_ACTION,
                fetchRequests: FETCH_REQUESTS
            }),
            setPageAndFetch(page) {
                this.setPage(page);
                this.fetchRequests();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/search/OrganismSearchResultsRequests.vue